import React, { useEffect, useState } from 'react';

export const DownloadAttachmentIcon = () => {

  const [color, setColor] = useState('');
  const DOMstyle = document.documentElement.style;

  // On Init
  useEffect(() => {
    const color = DOMstyle.getPropertyValue("--custom-primary-background-color");
    setColor(color);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20.9292 13.4111L15.9181 18.4222M15.9181 18.4222L10.907 13.4111M15.9181 18.4222V8.40004" stroke={color} strokeWidth="2" strokeLinecap="round" />
        <path d="M10.7993 24L21.5993 24" stroke={color} strokeWidth="2" strokeLinecap="round" />
      </svg>
    </>
  );
}